export const emptyPagination = {
	count: 0,
	currentPage: 1,
	perPage: 0,
	total: 0,
	totalPages: 0,
};
